import React from "react";

const BillPrintFooter = () => {
  return (
    <div style={{display: "flex", justifyContent: "center"}}>
      <div id="footer"  style={{position: "fixed", bottom: 0}}>
        <p style={{textAlign: "center"}}>
          E-mail -
          <span
            data-sheets-userformat='{"2":577,"3":{"1":0},"9":2,"12":0}'
            data-sheets-value='{"1":2,"2":"thesmilearc@gmail.com"}'
          >
            thesmilearc@gmail.com
          </span>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
          www.
          <span
            data-sheets-userformat='{"2":577,"3":{"1":0},"9":2,"12":0}'
            data-sheets-value='{"1":2,"2":"thesmilearc@gmail.com"}'
          >
            thesmilearc.com
          </span>
          &nbsp;
        </p>
        <div style={{textAlign: "center"}}>
          ______________________________________________________________________________________
          <br></br>
        </div>
        <div style={{textAlign: "center"}}>
          Contact/Appointment No: 01717216653, 01970610006&nbsp;
        </div>
        <div style={{textAlign: "center"}}>
          93/3 dhap jail road Opposite bangladesh bank Rangpur<br></br>
        </div>
        <p style={{textAlign: "center"}}>
          Powered By <a href="http://roobnet.com/">ROOBNET.COM</a>
          <a href="http://rooberp.com/DENTRINO">/</a>DENTRINO
        </p>
      </div>
    </div>
  );
};

export default BillPrintFooter;
